import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { DeviceInterface, setEditId, setEditError, selectDeviceById } from "../../../store/mine_craft/devicesSlice";
import { updateDevice, fetchDevice } from "../../../actions/mine_craft/devicesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.mineCraft.devices.editId);
  const error   = useAppSelector(state => state.mineCraft.devices.editError);
  const comment = useAppSelector(state => selectDeviceById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchDevice(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: DeviceInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: DeviceInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateDevice({ id, data: formData }));

    if (updateDevice.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-comment'>
        <h6 className="v-content-label">Edit Device</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={comment} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
